"use strict";
import React from "react";
import PropTypes from "prop-types";

class Paiger extends React.Component {
    static propTypes = {
        resultPerPages: PropTypes.array
    };

    static defaultProps = {
        resultPerPages: [ 100, 50, 25, 10, 5 ]
    };

    handleChangePageSize = (event) => {
        const value = Number(event.target.value);
        this.props.onChangePageSize(value);
    };

    handleChangePage = (value) => {
        this.props.onChangePage(value);
    };

    handleClickPrevPage = (currentPage) => {
        this.handleChangePage(currentPage - 1);
    };

    handleClickNextPage = (currentPage) => {
        this.handleChangePage(currentPage + 1);
    };

    render() {
        const totalPages = this.props.totalPages;
        const currentPage = this.props.currentPage;
        const pagesToRender = totalPages > 10 ? 10 : totalPages;
        const lastPage = totalPages;
        let resultsPerPageText = this.props?.resultsPerPageText || "Results Per Page";
        let startPage = 1;
        let endPage = pagesToRender;

        if (currentPage - pagesToRender / 2 > 0) {
            startPage = currentPage - pagesToRender / 2;
            endPage = currentPage + pagesToRender / 2 - 1;
        }

        if (currentPage + pagesToRender / 2 > totalPages) {
            startPage = totalPages - pagesToRender + 1;
            endPage = totalPages;
        }

        let pageList = [];

        pageList.push(<li key="firstPaige">{currentPage > 1 ? <a onClick={this.handleChangePage.bind(this, 1)} aria-label="Previous" className="prev" title="Previous Results">&lt;&lt;</a> : false}</li>);
        pageList.push(<li key="previous">{currentPage > 1 ? <a onClick={this.handleClickPrevPage.bind(this, currentPage)} aria-label="Previous" className="prev" title="Previous Results">&lt;</a> : false}</li>);

        for (let i = startPage; i <= endPage; i++) {
            let li = (i === currentPage) ? <li key={i}><span>{i}</span></li> : <li key={i}><a onClick={this.handleChangePage.bind(this, i)}>{i}</a></li>;
            pageList.push(li);
        }

        pageList.push(<li key="next">{currentPage < totalPages ? <a onClick={this.handleClickNextPage.bind(this, currentPage)} aria-label="Next" className="next" title="Next Results">&gt;</a> : false}</li>);
        pageList.push(<li key="lastPaige">{currentPage < totalPages ? <a onClick={this.handleChangePage.bind(this, lastPage)} aria-label="Next" className="next" title="Next Results">&gt;&gt;</a> : false}</li>);

        const renderResultPerPages = this.props.resultPerPages.map((value) => {return <option key={value} value={value}>{value}</option>});
        return (
            <div className="pagination-container">
                <div className="form-group select pull-left">
                    <label className="control-label" htmlFor="rs-sort">{resultsPerPageText}</label>
                    <select
                        className="form-control hasCustomSelect"
                        id="rs-sort"
                        onChange={this.handleChangePageSize}
                        value={this.props.pageSize}
                        defaultValue={this.props.pageSize}
                    >
                        {renderResultPerPages}
                    </select>
                </div>

                <nav>
                    <ul className="pagination pull-right">
                        {pageList}
                    </ul>
                </nav>
            </div>
        );
    }
}

module.exports = Paiger;